import { render, staticRenderFns } from "./snp-admin.vue?vue&type=template&id=42b9aaec&"
import script from "./snp-admin.vue?vue&type=script&lang=js&"
export * from "./snp-admin.vue?vue&type=script&lang=js&"
import style0 from "./snp-admin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports